export enum REFUND_FLOW_STAGE {
  UPLOAD = 'upload',
  VIEWER = 'viewer',
  SCANNING = 'scanning',
  ITEMS = 'items',
  SUMMARY = 'summary',
}

export enum ANALYZE_INVOICE_STATUS {
  ITEMS_FOUND = 'items_found',
  NO_DATA = 'no_data',
}

export enum MEDICAL_EQUIPMENT_MOCK_SCENARIO {
  ITEMS_FOUND = 'items_found',
  NO_DATA = 'no_data',
  NO_DATA_OLD = 'no_data_old',
  NO_DATA_ITEMS = 'no_data_items',
  ERROR = 'error',
}

export enum REFUND_FALLBACK_REASON {
  INVOICE_TOO_OLD = 'invoice_too_old',
  NO_FAST_REFUND_ITEMS = 'no_fast_refund_items',
}

export enum UPLOAD_VALIDATION_ERROR {
  INVALID_FORMAT = 'invalid_format',
  FILE_TOO_LARGE = 'file_too_large',
}

/** Each request has a single invoice with one attached file. */
export const MAX_MEDICAL_EQUIPMENT_FILES = 1;

export const MAX_MEDICAL_EQUIPMENT_FILE_SIZE_IN_MB = 15;
export const MAX_MEDICAL_EQUIPMENT_FILE_SIZE_IN_BYTES =
  MAX_MEDICAL_EQUIPMENT_FILE_SIZE_IN_MB * 1024 * 1024;
